import React, { useCallback, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";

import trophyIcon from "Assets/trophy.png";
import shareIcon from "Assets/share.png";
import settingIcon from "Assets/setting.png";

import Stopwatch from "Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/Stopwatch";
import { MODALS } from "Containers/Pages/Modal";
import { setPublicModal } from "Store/features/public/publicStateSlice";
import { declareVictory } from "Store/features/public/publicPuzzleSlice";
import { shuffleArray } from "Util/puzzleProcessing";

import "./PublicQuiz.css";
import PublicGameButtonGroup from "Components/PublicGameButtonGroup";
import { recordUserGameStat } from "API/Puzzles";

const PublicQuiz = (props) => {
  const { onClickBack, questions, puzzleTitle, postcastUser } = props;
  const [incorrectIndex, setIncorrectIndex] = useState(null);
  const [correctIndex, setCorrectIndex] = useState(null);
  const [showScore, setShowScore] = useState(false);

  const dispatch = useDispatch();

  const winner = useSelector((state) => state.publicPuzzleSlice.puzzle.winner);
  const puzzleSlice = useSelector((state) => state.puzzleSlice);
  const puzzleId = useSelector((state) => state.publicPuzzleSlice.puzzleId);
  const puzzle = useSelector((state) => state.puzzleSlice?.puzzle);
  const authToken = useSelector(
    (state) => state.publicUserSlice.postcastAuthToken
  );
  const { time } = useSelector(
    (state) => state.publicPuzzleSlice.puzzle.timer
  );
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  useSelector((state) => state.puzzleSlice?.puzzle?.score);

  const handleAnswerOptionClick = useCallback(
    (index, isCorrect) => {
      if (isCorrect) {
        setCorrectIndex(index);
        dispatch(
          setPuzzleAndPuzzleType({
            ...puzzleSlice,
            puzzle: {
              ...puzzle,
              score: score + 1,
            },
          })
        );
        setScore(score + 1);
      } else {
        setIncorrectIndex(index);
        dispatch(
          setPuzzleAndPuzzleType({
            ...puzzleSlice,
            puzzle: {
              ...puzzle,
              score: score + 1,
            },
          })
        );
      }

      setTimeout(() => {
        clearAndAdvanceQuiz();
      }, 1000);
    },
    [questions, score, currentQuestion]
  );

  const recordGame = useCallback(async () => {
    if (!winner) {
      console.log("No winner");
      if (authToken) {
        console.log("Recording game", { authToken, puzzleId });
        recordUserGameStat( authToken, puzzleId, time, dispatch);
      }
      setShowScore(true);
      dispatch(declareVictory());
      dispatch(setPublicModal(MODALS.WINNER));
    }
  }, [authToken, puzzleId, dispatch, winner, setShowScore, time]);

  const clearAndAdvanceQuiz = useCallback(() => {
    setIncorrectIndex(null);
    setCorrectIndex(null);
    setCurrentQuestion(currentQuestion + 1);
    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions?.length) {
      dispatch(
        setPuzzleAndPuzzleType({
          ...puzzleSlice,
          puzzle: {
            ...puzzle,
            currentQuestion: nextQuestion,
          },
        })
      );
      // setCurrentQuestion(nextQuestion);
    } else {
      recordGame();
    }
  }, [currentQuestion]);

  const incrementCurrentQuestion = useCallback(() => {
    setCurrentQuestion(currentQuestion + 1);
  }, [currentQuestion]);

  const decrementCurrentQuestion = useCallback(() => {
    setCurrentQuestion(currentQuestion - 1);
  }, [currentQuestion]);

  const handleClickTrophyIcon = useCallback(() => {
    dispatch(setPublicModal(MODALS.WINNER));
  }, [dispatch]);

  const handleClickShareIcon = async () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Newsie: News Puzzle",
          text: "Play this game!",
          // text: `I solved today\'s Newsie with a score of ${score}`+ "\n" + `in: ${minutes}:${seconds} with ${incorrectGuesses} incorrect guesses`,
          // url
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText("play this game!");
        console.log("Content copied to clipboard");
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    }
  };

  if (!questions?.length)
    return () => (
      <div>
        <div className="empty-newsie-cta-text-container">Loading...</div>
      </div>
    );
  return (
    <div className="public-quiz-container">
      <div className="public-quiz-top-panel">
        <div className="crossword-clues-container-header">
          <b>Quiz | Time Elaped</b>
          <Stopwatch small={true} />
          <PublicGameButtonGroup />
        </div>

        {!showScore ? (
          <>
            <div className="public-quiz-question-count">
              <span>Question {currentQuestion + 1}</span>/{questions?.length}
            </div>
            <div className="public-quiz-question-text">
              {questions[currentQuestion]?.questionText}
            </div>
          </>
        ) : null}
      </div>

      <div className="public-quiz-answer-section">
        {questions[currentQuestion]?.options?.map((option, index) => (
          <div
            key={index}
            onClick={() => handleAnswerOptionClick(index, option.isCorrect)}
            className={`public-quiz-answer-section-button ${
              index === correctIndex ? "correct" : ""
            } ${index === incorrectIndex ? "incorrect" : ""}`}
          >
            {option.answerText}
          </div>
        ))}
        {showScore ? (
          <div className="score-section">
            You scored {score} out of {questions?.length}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PublicQuiz;
